<template>
  <div>
    <span>{{ title }}</span>
    <span class="channel">{{ channel }}</span>
  </div>
</template>

<script>
export default {
  name: 'ImRightContentTitle',
  props: {
    title: '',
    channel: ''
  }
}
</script>
<style lang="stylus" scoped>
.channel {
  font-size: 12px;
  color: rosybrown;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/ImRightContentTitle.vue